export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Subhead_Kerning-a7e17cde288af5525be26fc6f9b738c1.svg";